<template>
    <div>
        <b-card>
            <div slot="header" align="center">
                <b-row>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
                        <b-form-input v-model="nombreCaja" placeholder="Nombre Caja"></b-form-input>
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
                        <select class="form-control" v-model="ListaDeEstablecimientos">
                            <option
                                v-for="(nombre, index) in listasEstablecimiento"
                                :value="index"
                                :key="index"
                            >{{ nombre.nombreEstablecimiento }}</option>
                        </select>
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2">
                        <b-button 
                            @click="crearCaja()" 
                            variant="primary">
                            Crear Caja
                            <i class="fa fa-archive" ></i>
                        </b-button>
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="1">
                       <div class="col-md-12 text-center">
                            <b-button variant="secondary" @click="listarCajasCreadas">
                                <i class="fa fa-sync-alt"></i>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="pl-2" style="background-color:lightblue;border-radius:10px"><h3>Cajas Creadas</h3></div>
             <div v-if="cargando">
                <div class="col-md-12 text-center">
                    <h3>
                        Cargando
                        <i class="fa fa-spin fa-spinner"></i>
                    </h3>
                </div>
            </div>
            <div v-else>
            <b-row>
                <b-col cols="1" sm="2"	md="2"	lg="2" xl="12">
                    <b-table    
                        responsive
                        outlined
                        bordered
                        :items="cajasListas"
                        :fields="Lista_Cajas_Creadas">
                        <template slot="fechaCreacion" slot-scope="row">
                            <div v-if="row.item.created_at && row.item.created_at !=''">
                                {{row.item.created_at | moment('D-M-Y hh:mm:ss A')}}
                            </div>
                        </template>
                        <template slot="inicioCaja" slot-scope="row">
                            <div v-if="row.item.inicioCaja && row.item.inicioCaja !=null">
                                {{row.item.inicioCaja}}
                            </div>
                            <div v-else>
                                Aún no establecido
                            </div>
                        </template>
                        <template slot="cierreCaja" slot-scope="row">
                            <div v-if="row.item.cierreCaja && row.item.cierreCaja !=null">
                                {{row.item.cierreCaja}}
                            </div>
                            <div v-else>
                                Aún no establecido
                            </div>
                        </template>
                        <template slot="accion" slot-scope="row">
                        <b-button
                        size="sm"
                        variant="success"
                        @click="abrirCaja(row.item)">
                            Abrir Caja
                        </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="pl-2" style="background-color:lightblue;border-radius:10px"><h3>Cajas Abiertas</h3></div>
                </b-col>
            </b-row>
            <b-modal v-model="aperturaCaja">

            </b-modal>
            </div>
        </b-card>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name:"Caja",
    data() {
        return {
        cargando: false,
        nombreCaja:'',
        listasEstablecimiento:[],
        ListaDeEstablecimientos:0,
        cajasListas:[],
        Lista_Cajas_Creadas:[
            { key: "nombre", label:"Nombre Caja", sortable:true},
            { key: "establecimiento", label:"Establecimiento", sortable:true},
            { key: "fechaCreacion", label:"Fecha Creación", sortable:true},
            { key: "inicioCaja", label:"Inicio Caja", sortable:true},
            { key: "cierreCaja", label:"Cierre Caja", sortable:true},
            { key: "accion", label:"Acciones"}
        ],
        aperturaCaja:false,    
        }
    },
    mounted() {
        this.establecimientosListar();
        this.listarCajasCreadas();
    },
    methods:{
        crearCaja(){
            
            axios
            .post(process.env.VUE_APP_API_URL + "caja/crear",{
                token:this.$store.getters.userToken,
                nombre:this.nombreCaja,
                establecimiento:this.listasEstablecimiento[this.ListaDeEstablecimientos].idEstablecimiento
            })
            .then(response=>(
                this.infoCajaCreada = response.data,
                this.nombreCaja = '',
                this.ListaDeEstablecimientos = 0
            ))
             .catch(error=>(
                console.log(error)
            ))
        },
        establecimientosListar(){
            axios
            .post(process.env.VUE_APP_API_URL + "establecimientos/listar", {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listasEstablecimiento = response.data.data  
            ))
            .catch(error => (
                console.log(error)
            )); 
        },
        listarCajasCreadas(){
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + "caja/listar", {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.cajasListas = response.data.data,
                this.cargando = false
            ))
            .catch(error => (
                console.log(error)
            ));  
        },
        abrirCaja(id){
            this.aperturaCaja = true;
            // axios
            // .post(process.env.VUE_APP_API_URL + "caja/abrir", {
            //     token: this.$store.getters.userToken,
            //     idCaja: id.idCaja,
            //     apertura: '2023-08-23 15:09:50',
            //     observaciones:'ninguna',
            // })
            // .then(response => (
            //     this.listarCajasCreadas(),
            //     console.log('RESPUESTA',response.data)
            // ))
            // .catch(error => (
            //     console.log(error)
            // ));   
        }
    }
}

</script>
<style scoped>

</style>